export default "/dist/d7eeef7e0f6b2f8b1769e19839b587ff.png";